import { createContext, useContext } from 'react';
import { useI18n } from '../hooks/useI18n';

const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  const i18n = useI18n();

  return (
    <TranslationContext.Provider value={i18n}>
      {children}
    </TranslationContext.Provider>
  );
}

// Hook para usar em qualquer página
export function useTranslation() {
  return useContext(TranslationContext);
}
